/* global gtag fbq */

import jbs_api from '@/modules/jbs-api';
import { pickBy, map } from 'lodash-es';
import Latch from "@/modules/notify-latch";


var cancelTokens = {};
var isPollingBasket = false;

export default {
    namespaced: true,
    state: {
        '@ts': 0.0,
        allocated: false,
        items: [],
        totals: {
            subtotal: 0,
            shipping: 0,
            discount: 0,
            tax: 0,
            total: 0,
            total_exshipping: 0,
            tax_exshipping: 0,
            rangefrom: 0,
            rangeto: 0
        },
        coupons: [],
        expires_in: false,
        final_preorder: false,
        expires_at: false,
        expired_baskets: [],
        _adding: false,
        _last_updated_item: false,
        _last_added_item: false
    },
    getters: {
        dp_items(state) {
            return pickBy(state.items, function (o) { return o.duty === 'DP' && (o.stockstatus === 'Stock' || state.final_preorder); });
        },
        ib_items(state) {
            return pickBy(state.items, function (o) { return o.duty === 'IB' && (o.stockstatus === 'Stock' || state.final_preorder); });
        },
        dpp_items(state) {
            return pickBy(state.items, function (o) { return o.duty === 'DP' && (o.stockstatus === 'Pre-Order' || o.stockstatus === 'Apply') && !state.final_preorder; });
        },
        ibp_items(state) {
            return pickBy(state.items, function (o) { return o.duty === 'IB' && (o.stockstatus === 'Pre-Order' || o.stockstatus === 'Apply') && !state.final_preorder; });
        },
        gtag_items(state) {
            return map(state.items, function (o) {
                return {
                    id: o.sku,
                    name: o.title,
                    price: o.unit_cost,
                    quantity: o.quantity,
                    variant: o.duty
                }
            });
        },
    },
    mutations: {
        set_adding_state(state, payload) {
            state._adding = payload;
        },
        set_last_updated(state, payload) {
            state._last_updated_item = payload;
        },
        set_last_added(state, payload) {
            state._last_added_item = payload;
        },
        reset(state) {
            state['@ts'] = 0;
            state.items = [];
            state.totals = {
                subtotal: 0,
                shipping: 0,
                discount: 0,
                tax: 0,
                total: 0,
                rangefrom: 0,
                rangeto: 0
            };
            state.coupons = {};
            state.allocated = false;
            state.expires_in = false;
            state.expires_at = false;
            state._adding = false;
            state.final_preorder = false;
            state._last_updated_item = false;
            state._last_added_item = false;

        },
        update(state, payload) {

            if (!payload)
                return false;

            if (typeof payload.items === 'undefined')
                return false;

            if (typeof payload.totals === 'undefined')
                return false;

            if (payload['@ts'] && payload['@ts'] < state['@ts']) {
                console.log('Stale update.');
                return 'stale';
            }

            state.items = payload.items;
            state.totals = payload.totals;
            state.coupons = payload.coupons;
            state.expires_in = payload.expires_in;
            state.expires_at = new Date(new Date().getTime() + (state.expires_in * 1000)).getTime();
            state.allocated = payload.allocated;
            state.reserved = payload.reserved;
            state.final_preorder = payload.final_preorder;

            return payload['@ts'];
        },
        set_expired_baskets(state, payload) {
            state.expired_baskets = payload;
        }
    },
    actions: {
        enquire(context, payload) {
            return jbs_api.post('Enquire', payload);
        },
        apply_coupon(context, payload) {
            return jbs_api.put('Basket/Coupon', { code: payload }).then(function (response) {
                context.commit('update', response.state);
                return Promise.resolve(response);
            });
        },
        remove_coupon(context, payload) {
            return jbs_api.delete('Basket/Coupon', { code: payload }).then(function (response) {
                context.commit('update', response.state);
                return Promise.resolve(response);
            });
        },
        reserve_items(context) {

            if (cancelTokens['basket_reserve']) {
                cancelTokens['basket_reserve'].cancel('basket_reserve');
            }

            cancelTokens['basket_reserve'] = jbs_api.CancelToken.source();

            return jbs_api.post('Basket', {}, { queueName: 'basket_reserve', cancelToken: cancelTokens['basket_reserve'].token }).then(function (response) {
                cancelTokens['basket_reserve'] = false;
                context.commit('update', response.state);

            }).catch(function () {
                // TODO: Check for cancel and if not retry

                cancelTokens['basket_reserve'] = false;
            });
        },
        poll_until_reserved(context) {
            if (!context.state.reserved && isPollingBasket === false) {
                isPollingBasket = setInterval(() => {
                    context.dispatch('refresh_state', { skip_poll: true });
                    if (context.state.reserved || !context.state.allocated) {
                        clearInterval(isPollingBasket);
                        isPollingBasket = false;
                    }
                }, 5000);
            }
        },
        refresh_state(context, payload) {
            return jbs_api.get('Basket').then(function (response) {
                context.commit('update', response.state);

                if (typeof payload === 'undefined') {
                    payload = {};
                }

                if (
                    (!payload.skip_poll) &&
                    response.state.allocated &&
                    !response.state.reserved &&
                    Object.keys(response.state.items).length > 0
                ) {
                    context.dispatch('poll_until_reserved');
                }

                return response;
            })
        },
        update_quantity(context, data) {

            return jbs_api.patch('Basket', {
                key: data.key,
                quantity: parseInt(data.quantity)
            }, { queueName: 'basket_update' }).then(function (response) {
                context.commit('set_last_updated', response.data.key);
                context.commit('update', response.state);
                if (response.state.allocated && !response.state.reserved && Object.keys(response.state.items).length > 0) {
                    context.dispatch('poll_until_reserved');
                }
            })
        },
        add_item(context, data) {

            // ZUX.showBasket(data.product_id);

            if (Object.keys(context.state.items).length < 1) {

                // If there are no items in the basket, reset the basket expiry modal latches.

                Latch.reset("basket-expiring-soon-10");
                Latch.reset("basket-expiring-soon-30");
                Latch.reset("basket-expired");
            }

            context.commit('set_adding_state', data.product_id);
            return jbs_api.put('Basket', {
                product_id: data.product_id,
                quantity: parseInt(data.quantity)
            }, { queueName: 'basket_update' }).then(function (response) {
                context.commit('set_adding_state', false);
                context.commit('set_last_added', response.data.key);
                context.commit('update', response.state);
                if (response.state.allocated && !response.state.reserved) {
                    context.dispatch('poll_until_reserved');
                }

                if (!response.notices.error) {
                    window.dispatchEvent(new CustomEvent("notices", {
                        detail: {
                            success: [
                                { notice: "" + data.quantity + ' x ' + data.product_title + ' has been added to your basket.' },
                            ]
                        }
                    }))

                    gtag('event', 'add_to_cart', {
                        currency: 'GBP',
                        items: [{
                            id: response.data.sku,
                            name: response.data.title,
                            brand: response.data.producer,
                            category: response.data.category,
                            price: response.data.price,
                            quantity: data.quantity,
                            variant: response.data.duty
                        }],
                        value: response.data.price * data.quantity
                    });

                    fbq('track', 'AddToCart', {
                        content_name: response.data.title,
                        content_ids: [response.data.sku],
                        content_type: 'product',
                        value: response.data.price * data.quantity,
                        currency: 'GBP'
                    });
                }

                // setTimeout(function () {
                //     ZUX.hideBasket();
                // }, 1500);
            }).catch(function (error) {
                context.commit('set_adding_state', false);

                throw error;
            });
        },
        load_expired_baskets(context) {
            return jbs_api.get('ExpiredBasket').then((response) => {
                context.commit("set_expired_baskets", response.data);
            });
        }
    }
}